import React, {  Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';

/*Actions*/
import {
	getProductComparison
} from '../../../redux/actions';

import $ from 'jquery';

import AddToCart from '../common/AddToCart';
import AddToList from '../common/AddToList';

import { routes } from '../../../redux/api/routes';
let { productGEUrl, geUrlImageMigratedAssets } = routes;

class CompareProducts extends Component {

	constructor(props) {
		super(props);
		this.state = {
			comparisonData: null,
			onlyShowDifferences: false,
			productHeight: [],
			productWidth: [],
			productDepth: []
		}
	}

	componentDidMount() {
		var self = this;
		self.props.getProductComparison(`skus=${self.props.params.skus}`, response => {
			const comparisonData = response && response.responseObject;
			if(comparisonData){
				comparisonData.map((item, index) => {
					item.claims = _.find(item.attributes,["displayName", "Claims & Certifications"]);
					return null
				});
			}

			let productDimensions = comparisonData,
				prodtDimensions = [];
				productDimensions && productDimensions.map((item,index)=>{
				prodtDimensions.push(item.dimensions?item.dimensions:'');
				return null
			});

			let height = self.state.productHeight,
			width = self.state.productWidth,
			depth = self.state.productDepth;

			prodtDimensions.map((item,index)=>{
				let prodDimensions = item.toString().split("x");
				let productHeight = prodDimensions[0].split("H");
				let productWidth =  prodDimensions[1].split("W");
				let productDepth =  prodDimensions[2].split("D");
				height.push(productHeight[0]);
				width.push(productWidth[0]);
				depth.push(productDepth[0]);
				return null
			});
			self.setState({
				productHeight: height,
				productWidth: width,
				productDepth: depth,
				comparisonData: comparisonData
			});
		});
	}

	removeItem(sku, event) {
		event.preventDefault();
		var comparisonData = this.state.comparisonData;
		if(comparisonData.length === 2) {
			alert("You can only compare between 2 and 4 products.");
		} else {
			this.setState({
				comparisonData: _.pullAllBy(comparisonData, [{ "sku": sku }], "sku")
			});
		}
	}

	removeProduct(data){
		return data.map((item, index) => {
			return <td key={index}>
				<div>X <a href="" onClick={this.removeItem.bind(this, item.sku)}>Remove</a></div>
			</td>
		})
	}

	checkArrayContainsWord(array, word) {
		var contains = false;
		for(var i=0;array && i<array.length;i++) {
			if(array[i].indexOf(word) !== -1) {
				contains = true;
				break;
			}
		}
		return contains;
	}

	prepareAttributes(skus, products){
		let attributeKeys = new Set();
		//Extract attribute keys from all products
		products.map((item, index) => {
			item.attributes.map((itm, ind) => {
				if(itm.priority !== 0) attributeKeys.add(itm.name);
				return null
			});
			return null;
		});

		//Prepare display attributes
		let attributeList = Array.from(attributeKeys);
		attributeList = attributeList.map((attr) =>{
			let item = {};
			item.key = attr;
			item.values = [];
			for(let sku of skus){
				var currPrd = _.find(products, ["sku", sku]),
					attrAvail = _.find(currPrd.attributes, ["name", attr]);
				if(currPrd && attrAvail) {
					let entry = attrAvail;
					item.values.push(attrAvail.values && attrAvail.values.length > 0 ? attrAvail.values.map(itm => itm.value) : undefined);
					item.category = entry.definition;
					item.description = entry.displayName;
					item.priority = isNaN(entry.priority) ? -1 : parseInt(entry.priority, 10);
				} else {
					item.values.push(undefined);
				}
			}
			if((new Set(item && item.values && item.values.length > 0 && item.values.map(it => it && it.toString())).size === 1)){
				item.different = false;
			} else {
				item.different = true;
			}
			return item;
		});

		attributeList = window.convertToArrayOfObject(_.groupBy(attributeList, "category"), true);

		attributeList.map((item, index) => {
			item.hasDifferent = _.find(item.list, ["different", true])?true:false;
			item.list = _.sortBy(item.list, [(itm) => itm.description && itm.description.toLowerCase()]);
			return null;
		});

		return attributeList;
	}

	showHideRows(category, event) {
		event.preventDefault();
		$("."+category).toggle();
		var showHide = $(event.currentTarget).parent().find('a span.showHide');
		var plusMinus = $(event.currentTarget).parent().find('a span.plusMinus');
		showHide.html(showHide.html() === "show"?"hide":"show");
		plusMinus.html(plusMinus.html() === "-"?"+":"-");
	}

	prepareClassName(category) {
		return category.replace(/[\W\d_]/g, '').toLowerCase();
	}

	handleOnlyShowDifferencesOrAll(flag, event) {
		event.preventDefault();
		this.setState({
			onlyShowDifferences: flag
		});

		$('a span.showHide').html("show");
		$('a span.plusMinus').html("-");
	}
	
	formatNumber2Decimal(number) {
		if (number) {
		  return "$" + parseFloat(number).toLocaleString();
		} else {
		  return "";
		}
	  }
    render() {
		var self = this;
		let comparisonData = this.state.comparisonData;
		let	skus = [],
			displayAttributes = [];
		if(comparisonData){
			comparisonData.map((item, index) => {
				skus.push(item.sku);
				return null
			});
			displayAttributes = this.prepareAttributes(skus, comparisonData);
		}

		let sku = [],
        wishListSku = [];
        //for gettting current cart object
        if(this.props.state.cart&&this.props.state.cart.cart&&this.props.state.cart.cart.cartItems&&this.props.state.cart.cart.cartItems.length>0){
            let {cart} = this.props.state.cart,
            cartItems = cart.cartItems;
            //sku = [];
            cartItems.map((item,index)=>{
                sku.push(item.product);
                return null
            });
        }
        //for gettting current List object
        if(this.props.state.list&&this.props.state.list.list&&this.props.state.list.list.wishlistItems&&this.props.state.list.list.wishlistItems.length>0){
            let {list} = this.props.state.list,
            wishlistItems = list.wishlistItems;
            //sku = [];
            wishlistItems.map((item,index)=>{
                wishListSku.push(item.item);
                return null
            });
        }

        return (
            <div className="comparePageContent">
                <div className="push">
                    <p><Link className="uppercase bold noUnderline" to={"/search-result/"+this.props.params.typeOfSearch+"/"+encodeURI(this.props.params.searchKeyword.trim())}>&lt; Back to Product Results</Link></p>
                </div>
                <h1 className="pageTitle">Compare Products</h1>
                <hr />
                <table id="compareTable" cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr className="removeRow">
                            <td className="firstCol">&nbsp;</td>
							{comparisonData && this.removeProduct(comparisonData)}
                        </tr>
                        <tr className="productInfoRow">
                            <td className="firstCol">
								{this.state.onlyShowDifferences
									?<div id="differencesBox" className="roundedCorners" style={{zoom: 1, border: 'none', position: 'relative'}}>
	                                    <span>Show All Features</span><br />
	                                    <a href="" onClick={this.handleOnlyShowDifferencesOrAll.bind(this, false)}>Show all features for these products.</a>
	                                </div>
									:<div id="differencesBox" className="roundedCorners" style={{zoom: 1, border: 'none', position: 'relative'}}>
	                                    <span>Show Me the Differences</span><br />
	                                    <a href="" onClick={this.handleOnlyShowDifferencesOrAll.bind(this, true)}>Only show features that are different between models.</a>
	                                </div>
								}
                            </td>
							{comparisonData && comparisonData.map((item,index)=>{
								return <td key={index}>
                                    <div className="productImage"><img src={item.images.length>0 ?item.images.filter((itm)=>{return itm.defaultImage == true})[0].imagePath:""} alt={item.sku} title={item.sku} className="doubleBorder" height={100} width={96} /></div>
                                    <Link to={"/product-specs/product-number/"+item.sku}>{item.description}</Link><br />
                                    Model #: {item.sku}
									<p>MSRP : {this.formatNumber2Decimal(item.msrp)}</p>
                                    <p>
										{this.checkArrayContainsWord(item.claims, "ENERGY STAR") &&
                                        	<img src={geUrlImageMigratedAssets+"/images/common/logos/logo-energy_star.gif"} alt="ENERGY STAR" title="ENERGY STAR" height={41} width={41} />
										}
										{this.checkArrayContainsWord(item.claims, "MADE IN AMERICA") &&
                                        	<img src={geUrlImageMigratedAssets+"/images/common/logos/logo-america_at_work.png"} alt="MADE IN AMERICA" title="MADE IN AMERICA" height={41} width={41} />
										}
                                        {/* additional img tags separated by space only */}
                                    </p>
                                    {/* CNET CHANGE HERE: ...and insert ONE of the following... */}
									<AddToList fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} getPimDataForCartItem={this.props.getPimDataForCartItem} item={item.sku} itemDescription={item.description} itemType={item.itemType} getZipCode={self.props.getZipCode} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
        							<AddToCart brand={item.brand} category={item.category} fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} item={item.sku} itemDescription={item.description} itemType={item.itemType} makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
                                </td>
							})}
                        </tr>
                    </thead>
						{displayAttributes.map((item, index) => {
							if(item.key === 'FILTER') return null;
							return <tbody key={index} className={this.state.onlyShowDifferences && !item.hasDifferent?"hide":""}>
								<tr className="subHeadingRow">
	                                <td colSpan={this.props.params.skus.split("+").length+1}>
										<a href="" onClick={self.showHideRows.bind(this, self.prepareClassName(item.key))} style={{float: 'right'}}><span className="showHide">hide</span> {item.key}</a>
										<a href="" onClick={self.showHideRows.bind(this, self.prepareClassName(item.key))} className="bold"><span className="plusMinus">-</span> {item.key}</a>
									</td>
	                            </tr>
								{item.list.map((itm, ind) => {
									return <tr key={ind} style={{display: (!itm.different && this.state.onlyShowDifferences?'none':'table-row')}} className={(itm.different?"differenceRow ":"")+self.prepareClassName(itm.category)}>
										<td className="firstCol">{itm.description}</td>
										{skus.map((item2, index2) => {
											if(itm.category==="WEIGHTS & DIMENSIONS"){
												if(itm.description==="Overall Width")
													return <td key={index2} className='tdCols'>{self.state.productWidth[index2]}<b></b></td>
												else if(itm.description==="Overall Height")
													return <td key={index2}className='tdCols'>{self.state.productHeight[index2]}<b></b></td>
												else if(itm.description==="Overall Depth")
													return <td key={index2} className='tdCols'>{self.state.productDepth[index2]}<b></b></td>
												else
													return <td key={index2} className='tdCols'><b>{parseFloat(itm.values[index2]).toFixed(2)}</b></td>
											}
											else if(itm.different){
												return <td key={index2} className='tdCols'><b>{itm.values[index2] && itm.values[index2].join(', ')}</b></td> 
											} else {
												return <td key={index2} className='tdCols'>{itm.values[index2] && itm.values[index2].join(', ')}</td> 
											}
										})}
	                                </tr>
								})}
		                    </tbody>
						})}
					<tbody>
							<tr className="subHeadingRow">
								<td colSpan={this.props.params.skus.split("+").length + 1}>
									<a href="" onClick={self.showHideRows.bind(this, 'certifications')} style={{ float: 'right' }}>
										<span className="showHide">hide</span> CERTIFICATIONS
									</a>
									<a href="" onClick={self.showHideRows.bind(this, 'certifications')} className="bold">
										<span className="plusMinus">-</span> CERTIFICATIONS
									</a>
								</td>
							</tr>
							<tr className="certifications">
								<td className="firstCol">Claims &amp; Certifications</td>
									{comparisonData && comparisonData.map((item, index) => {
										const claimsValues = item.claims && item.claims.values
											? item.claims.values.map(v => v.value)
											: [];
										return (
											<td key={index}>
												{claimsValues.length > 0
													? claimsValues.map((val, i) => (
														<span key={i} style={{ display: 'block' }}>{val}</span>
													))
													: <span style={{ color: '#999', fontSize: 12 }}>None</span>
												}
											</td>
										);
									})}
							</tr>
						</tbody>
                    <tfoot>
                        <tr className="productInfoRow">
                            <td className="firstCol">&nbsp;</td>
							{comparisonData && comparisonData.map((item, index)=>{
                                return <td key={index}>
									<Link to={"/product-specs/product-number/"+item.sku}>{item.description}</Link><br />
                                    Model #: {item.sku}
    								<AddToList fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} item={item.sku} itemDescription={item.description} itemType={item.itemType} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
									{/* CNET CHANGE HERE: ...and insert ONE of the following... */}
									<AddToCart brand={item.brand} category={item.category} fireGTMTag={this.props.fireGTMTag} getShippingAddressesDetails={this.props.getShippingAddressesDetails} getPimDataForCartItem={this.props.getPimDataForCartItem} item={item.sku} itemDescription={item.description} itemType={item.itemType} getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability} />
                            	</td>
							})}
                        </tr>
                        <tr className="removeRow">
                            <td className="firstCol">&nbsp;</td>
							{comparisonData && this.removeProduct(comparisonData)}
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getProductComparison: (queryStringParams, callback) => dispatch(getProductComparison(queryStringParams, callback))
})

CompareProducts = connect(mapStateToProps, mapDispatchToProps)(CompareProducts);
export default CompareProducts;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/CompareProducts/index.js